import _ from 'lodash'
import { PureComponent } from 'react'
import Notification from 'rc-notification'

// Bind the Ant Design notification system into our
// default React context.

export default class BoundNotification extends PureComponent {
    state = {}
    called = false
    constructor(props) {
        super(props)

        Notification.newInstance = this.newInstance
    }

    newInstance = (properties, callback) => {
        let called = false
        const id = _.uniqueId('rc-note')
        const ref = notification => {
            if (called) {
                return
            }

            called = true

            callback({
                notice(noticeProps) {
                    notification.add(noticeProps)
                },
                removeNotice(key) {
                    notification.remove(key)
                },
                component: notification,
                destroy() {
                    this.setState({ [id]: null })
                },
            })
        }

        const instance = <Notification {...properties} ref={ref} />

        this.setState({ [id]: instance })
    }

    message = () =>
        _.map(this.state, (value, key) => <div key={key}>{value}</div>)

    componentWillUnmount() {
        Notification.newInstance = () => {
            throw new Error('`Notification.newInstance` not bound')
        }
    }

    render() {
        return <>{this.message()}</>
    }
}
